<div class="app-container">
  @if (isHeaderAndFooterVisible()) {
    <mdcr-header />
  }

  <router-outlet />

  @if (isHeaderAndFooterVisible()) {
    <mdcr-footer />
  }
</div>

@if (isPopupOpened()) {
  <mdcr-popup />
}

@if (isSignInModalOpened()) {
  <mdcr-sign-in-modal />
}

@if (isToastOpened()) {
  <mdcr-toast />
}

<mdcr-session-expiration />
